import React from 'react';
import PropTypes from 'prop-types';
import RadioButtons from './RadioButtons';

const LightRadioButtons = (props) => {
  const {
    className,
    ...rest
  } = props;
  return (
    <RadioButtons
      {...rest}
      className={`${className} ds-radio-buttons-dark-background`}
    />
  );
};

LightRadioButtons.defaultProps = {
  className: '',
};

LightRadioButtons.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      children: PropTypes.node,
      defaultChecked: PropTypes.bool,
      text: PropTypes.string,
      value: PropTypes.string,
    }),
  ).isRequired,
};

export default LightRadioButtons;



// WEBPACK FOOTER //
// ./src-react/DesignSystem/RadioButtons/LightRadioButtons.jsx